<template>
  <div class="">
    <Landing :landingData="landingData" />
    <!-- <Types /> -->
    <Works />
    <ForJobSeeker />
    <Testimonial />
    <PartnerCompanies />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>

<script>
import Landing from '../components/Homev2/JobSeeker/LandingJobSeeker.vue'
import Contact from '../components/isaMain/Contact.vue'
import PartnerCompanies from '../components/Homev2/Recruit/PartnerCompanies.vue'
// import Types from '../components/Homev2/Recruit/TypesIsa.vue'
import Testimonial from '../components/BongoIsa/Saying.vue'
import Works from '../components/Homev2/Recruit/Works.vue'
import ForJobSeeker from '../components/Homev2/JobSeeker.vue'

export default {
  data() {
    return {
      landingData: {
        title: 'Get hired based on your skill sets',
        paragraph:
          'We have trained about 5000+ people so far in the areas of Data Science, Machine Learning, UX/UI, Digital Marketing and Artificial Intelligence. Let us help you get the right job in the most efficient way.',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        landingImage: require('../assets/homeV2/Recruiter/Frame (1).png'),
      },

      howWillitPay: {
        numericalColor: '#1EBCE5',
        stepsTextColor: '#EA4424',
        steps: [],
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        companyName: 'CMED',
      },
    }
  },
  components: {
    Landing,
    Contact,
    Testimonial,
    PartnerCompanies,
    // Types,
    Works,
    ForJobSeeker,
  },
  created() {
    this.Loaded()
  },
}
</script>

<style></style>
